import { useEffect, useState } from "react";
import { Combobox } from "./ui/combobox";
import { useGetCustomerNamesQuery } from "../store/api/customerApi";
import { Building2, CheckIcon } from "lucide-react";
import { cn } from "../lib/utils";

const CustomerDropdown = ({ defaultValue, classes, icon }) => {
  const { data, isLoading, isFetching } = useGetCustomerNamesQuery({});
  const [names, setNames] = useState([]);

  useEffect(() => {
    setNames(
      data?.map((i) => ({
        label: i.organization,
        value: i.id.toString(),
        // project: i.project
      }))
    );
  }, [data]);

  if (isLoading || isFetching || !names?.length) {
    return <div></div>;
  }

  return (
    <Combobox
      label="Select Customer"
      classes={classes || { button: "w-60", popoverContent: "w-60" }}
      data={names}
      keywords={["label"]}
      icon={icon || <Building2 className="w-4" />}
      defaultValue={defaultValue || names[0]?.value.toString()}
      renderItem={(item, value) => (
        <>
          <CheckIcon
            className={cn(
              "mr-2 h-4 w-4",
              value === item.value ? "opacity-100" : "opacity-0"
            )}
          />
          <div>
            <div>{item.label}</div>
            <div className="text-xs text-gray-400">{item.organization}</div>
          </div>
        </>
      )}
    />
  );
};

export default CustomerDropdown;
